import React from 'react';
import { LEFT_NAVIGATION_DATA_TESTID } from '../../constants/index.js';
import { ItemRenderer } from '../../exported-related/index.js';
import type { DSLeftNavigationT } from '../../react-desc-prop-types.js';
import {
  StyledRightContainer,
  StyledRightLabel,
  StyledSectionContainer,
  StyledSectionLabel,
  StyledVerticalSeparator,
} from '../styled.js';

export const ItemSection = (props: DSLeftNavigationT.ComponentProps): JSX.Element => {
  const {
    item,
    item: {
      itemOpts: { label, LeftComponent, RightComponent, labelRightSection, labelDataTestId },
    },
    ctx,
    ctx: { leftNavProps, setFocusedItem },
  } = props;

  const getOwnerProps = React.useCallback(() => leftNavProps, [leftNavProps]);
  const getOwnerPropsArguments = React.useCallback(() => ({}), []);
  return (
    <ItemRenderer
      item={{
        ...item,
        itemOpts: { ...item.itemOpts, selectable: false, focuseable: false },
        CollapsedComponent: null,
      }}
      minHeight="32px"
      paddingTop="8px"
    >
      <StyledSectionContainer
        cols={['min-content', 'auto', 'min-content', 'auto']}
        pl="xxs"
        alignItems="center"
        data-testid={LEFT_NAVIGATION_DATA_TESTID.SECTION_CONTAINER} // https://jira.elliemae.io/browse/PUI-15589
        getOwnerProps={getOwnerProps}
        getOwnerPropsArguments={getOwnerPropsArguments}
      >
        {LeftComponent ? <LeftComponent ctx={ctx} item={item} /> : <div />}
        <StyledSectionLabel
          data-testid={labelDataTestId || LEFT_NAVIGATION_DATA_TESTID.SECTION_LABEL}
          getOwnerProps={getOwnerProps}
          getOwnerPropsArguments={getOwnerPropsArguments}
        >
          {label}
        </StyledSectionLabel>
        <StyledVerticalSeparator
          data-testid={LEFT_NAVIGATION_DATA_TESTID.VERTICAL_SEPARATOR} // https://jira.elliemae.io/browse/PUI-15589
          getOwnerProps={getOwnerProps}
          getOwnerPropsArguments={getOwnerPropsArguments}
        />
        <StyledRightLabel
          data-testid={LEFT_NAVIGATION_DATA_TESTID.SECTION_RIGHT_LABEL} // https://jira.elliemae.io/browse/PUI-15589
          getOwnerProps={getOwnerProps}
          getOwnerPropsArguments={getOwnerPropsArguments}
        >
          {labelRightSection}
        </StyledRightLabel>
      </StyledSectionContainer>
      <StyledRightContainer
        ml="auto"
        onFocus={(e: React.FocusEvent) => {
          setFocusedItem(null);
          e.stopPropagation();
        }}
        onKeyDown={(e: React.KeyboardEvent) => e.stopPropagation()}
        pr="xxs2"
        alignItems="center"
        data-testid={LEFT_NAVIGATION_DATA_TESTID.RIGHT_CONTAINER} // https://jira.elliemae.io/browse/PUI-15589
        getOwnerProps={getOwnerProps}
        getOwnerPropsArguments={getOwnerPropsArguments}
      >
        {RightComponent && <RightComponent ctx={ctx} item={item} />}
      </StyledRightContainer>
    </ItemRenderer>
  );
};
